<template>
  <div
    class="w-auto h-auto collapse navbar-collapse max-height-vh-95 pb-3 h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li
        class="nav-item"
        style="overflow: hidden !important"
        v-if="permissions.find((item) => item.code === '2008')?.active == true"
      >
        <sidenav-collapse
          :navText="permissions.find((item) => item.code === '2008')?.name"
          :to="{ name: 'Dashboard' }"
        >
          <template #icon>
            <shop />
          </template>
        </sidenav-collapse>
      </li>

      <p
        v-if="
          permissions.find((item) => item.code === '2005')?.active == true ||
          permissions.find((item) => item.code === '2006')?.active == true ||
          permissions.find((item) => item.code === '2007')?.active == true
        "
        class="m-0 mt-1 px-3 font-bold text-uppercase text-uppercase"
        style="
          font-weight: 600;
          font-size: 12px !important;
          color: #82d616 !important;
        "
      >
        Olt
      </p>

      <!-- port  -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2007')?.active == true"
      >
        <sidenav-collapse
          :navText="permissions.find((item) => item.code === '2007')?.name"
          :to="{ name: 'OltDataPort' }"
        >
          <template #icon>
            <Port />
          </template>
        </sidenav-collapse>
      </li>

      <!-- olt list -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2006')?.active == true"
      >
        <sidenav-collapse
          :navText="permissions.find((item) => item.code === '2006')?.name"
          :to="{ name: 'OltList' }"
        >
          <template #icon>
            <OltList />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item"
        v-if="permissions.find((item) => item.code === '2021')?.active == true"
      >
        <sidenav-collapse
          :navText="permissions.find((item) => item.code === '2021')?.name"
          :to="{ name: 'DownCount' }"
        >
          <template #icon>
            <Switch />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item"
          v-if="permissions.find((item) => item.code === '2020')?.active == true"
      >
        <sidenav-collapse
           :navText="permissions.find((item) => item.code === '2020')?.name"
          :to="{ name: 'OnuDownScanner' }"
        >
          <template #icon>
            <Switch />
          </template>
        </sidenav-collapse>
      </li>

      <!-- share olt -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2005')?.active == true"
      >
        <sidenav-collapse
          :navText="permissions.find((item) => item.code === '2005')?.name"
          :to="{ name: 'Share' }"
        >
          <template #icon>
            <Share />
          </template>
        </sidenav-collapse>
      </li>

      <p
        v-if="
          permissions.find((item) => item.code === '2003')?.active == true ||
          permissions.find((item) => item.code === '2004')?.active == true
        "
        class="m-0 mt-1 px-3 font-bold text-uppercase"
        style="
          font-weight: 600;
          font-size: 12px !important;
          color: #82d616 !important;
        "
      >
        Switch
      </p>

      <!-- switch -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2004')?.active == true"
      >
        <sidenav-collapse
          :navText="permissions.find((item) => item.code === '2004')?.name"
          :to="{ name: 'SwitchList' }"
        >
          <template #icon>
            <Switch />
          </template>
        </sidenav-collapse>
      </li>

      <!-- switch list -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2003')?.active == true"
      >
        <sidenav-collapse
          :navText="permissions.find((item) => item.code === '2003')?.name"
          :to="{ name: 'OltPort' }"
        >
          <template #icon>
            <SwitchList />
          </template>
        </sidenav-collapse>
      </li>

      <!-- ######################### monitors ################# -->

      <p
        v-if="
          permissions.find((item) => item.code === '2014')?.active == true ||
          permissions.find((item) => item.code === '2015')?.active == true ||
          permissions.find((item) => item.code === '2011')?.active == true ||
          permissions.find((item) => item.code === '2012')?.active == true ||
          permissions.find((item) => item.code === '2013')?.active == true 
        "
        class="m-0 mt-1 px-3 font-bold text-uppercase"
        style="
          font-weight: 600;
          font-size: 12px !important;
          color: #82d616 !important;
        "
      >
        Monitor
      </p>

      <!-- Pop Monitor -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2014')?.active == true"
      >
        <sidenav-collapse :navText="permissions.find((item) => item.code === '2014')?.name" :to="{ name: 'Pop Monitor' }">
          <template #icon>
            <Log />
          </template>
        </sidenav-collapse>
      </li>

      <!-- pop list -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2015')?.active == true"
      >
        <sidenav-collapse :navText="permissions.find((item) => item.code === '2015')?.name" :to="{ name: 'Pop List' }">
          <template #icon>
            <Log />
          </template>
        </sidenav-collapse>
      </li>
      <!-- pop log -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2011')?.active == true"
      >
        <sidenav-collapse :navText="permissions.find((item) => item.code === '2011')?.name" :to="{ name: 'Pop Log' }">
          <template #icon>
            <Log />
          </template>
        </sidenav-collapse>
      </li>

      <!-- package list -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2012')?.active == true"
      >
        <sidenav-collapse :navText="permissions.find((item) => item.code === '2012')?.name" :to="{ name: 'Ping' }">
          <template #icon>
            <Package />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="permissions.find((item) => item.code === '2013')?.active == true">
        <sidenav-collapse
          :navText="permissions.find((item) => item.code === '2013')?.name"
          :to="{ name: 'Pop Area' }"
        >
          <template #icon>
            <Log />
          </template>
        </sidenav-collapse>
      </li>

      <!-- Device Monitor -->
      <!-- <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2013')?.active == true"
      >
        <sidenav-collapse
          :navText="permissions.find((item) => item.code === '2013')?.name"
          :to="{ name: 'Device Monitor' }"
        >
          <template #icon>
            <Log />
          </template>
        </sidenav-collapse>
      </li> -->

      <!-- #################admin #################### -->
      <p
        v-if="permissions.find((item) => item.code === '2000')?.active == true"
        class="m-0 mt-1 px-3 font-bold text-uppercase"
        style="
          font-weight: 600;
          font-size: 12px !important;
          color: #82d616 !important;
        "
      >
        Admin
      </p>

      <!-- users -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2000')?.active == true"
      >
        <sidenav-collapse navText="Users" :to="{ name: 'Users' }">
          <template #icon>
            <Users />
          </template>
        </sidenav-collapse>
      </li>

      <!-- roles -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2000')?.active == true"
      >
        <sidenav-collapse navText="Roles" :to="{ name: 'Roles' }">
          <template #icon>
            <Roles />
          </template>
        </sidenav-collapse>
      </li>

      <!-- Permissions -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2000')?.active == true"
      >
        <sidenav-collapse
          navText="Olt Permissions"
          :to="{ name: 'RolePermissions' }"
        >
          <template #icon>
            <Permission />
          </template>
        </sidenav-collapse>
      </li>

      <!-- branch -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2000')?.active == true"
      >
        <sidenav-collapse navText="Branch" :to="{ name: 'Branch' }">
          <template #icon>
            <Branch />
          </template>
        </sidenav-collapse>
      </li>

      <!-- ######################### others ################# -->

      <p
        v-if="
          permissions.find((item) => item.code === '2001')?.active == true ||
          permissions.find((item) => item.code === '2002')?.active == true
        "
        class="m-0 mt-1 px-3 font-bold text-uppercase"
        style="
          font-weight: 600;
          font-size: 12px !important;
          color: #82d616 !important;
        "
      >
        Others
      </p>

      <!-- sys log -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2002')?.active == true"
      >
        <sidenav-collapse
          :navText="permissions.find((item) => item.code === '2002')?.name"
          :to="{ name: 'Log' }"
        >
          <template #icon>
            <Log />
          </template>
        </sidenav-collapse>
      </li>

      <!-- package list -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2001')?.active == true"
      >
        <sidenav-collapse
          :navText="permissions.find((item) => item.code === '2001')?.name"
          :to="{ name: 'Package List' }"
        >
          <template #icon>
            <Package />
          </template>
        </sidenav-collapse>
      </li>
      <!-- Service List -->
      <li
        class="nav-item"
        v-if="permissions.find((item) => item.code === '2016')?.active == true"
      >
        <sidenav-collapse
          :navText="permissions.find((item) => item.code === '2016')?.name"
          :to="{ name: 'Service' }"
        >
          <template #icon>
            <Package />
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>

  <!-- <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <button
      @click="logoutUser"
      title="Logout"
      class="btn bg-gradient-success w-100"
      type="button"
    >
      <span class=""
        ><i class="fas fa-sign-out-alt text-lg" aria-hidden="true"></i
      ></span>
      <span v-if="loading" class="spinner-border spinner-border-sm mx-3"></span>
    </button>
  </div> -->
</template>
<script>
import SidenavCollapse from "./SidenavCollapse.vue";
import Shop from "../../components/Icon/Shop.vue";
import Branch from "../../components/Icon/Branch.vue";

import Users from "../../components/Icon/Sidebar/Users.vue";
import Roles from "../../components/Icon/Sidebar/Roles.vue";
import Permission from "../../components/Icon/Sidebar/Permission.vue";
import Log from "../../components/Icon/Sidebar/Log.vue";
import Package from "../../components/Icon/Sidebar/Package.vue";
import Switch from "../../components/Icon/Sidebar/Switch.vue";
import Share from "../../components/Icon/Sidebar/Share.vue";
import Port from "../../components/Icon/Sidebar/Port.vue";
import SwitchList from "../../components/Icon/Sidebar/SwitchList.vue";
import OltList from "../../components/Icon/Sidebar/OltList.vue";
import getProfileCheck from "@/services/check-profile.service";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      permissions: [],
      loading: false,
      title: "Soft UI Dashboard PRO",
      controls: "dashboardsExamples",
      isActive: "active",
      darkMode: false,
    };
  },
  components: {
    SidenavCollapse,
    /* SidenavCard, */
    Shop,
    OltList,
    Users,
    Roles,
    Permission,
    Branch,
    Log,
    Package,
    Switch,
    SwitchList,
    Share,
    Port,
  },
  mounted() {
    const savedDarkMode = localStorage.getItem("darkMode");
    if (savedDarkMode !== null) {
      this.darkMode = JSON.parse(savedDarkMode); // Update dark mode state
    }
    this.getCheckProfile();
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    async getCheckProfile() {
      try {
        let response = await getProfileCheck.getProfileCheck();
        this.permissions = response.user_role.menus;
        localStorage.setItem('permissions', JSON.stringify(this.permissions));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    logoutUser() {
      this.loading = true;
      this.$store.dispatch("auth/logout");
      this.loading = false;
    },
  },
};
</script>
